export * from './number-input-component-config.interface';
